import React, { ReactNode } from 'react'
import useStyles from './styles'
import clsx from 'clsx'

interface Props extends React.HTMLProps<HTMLInputElement> {
  info?: ReactNode
  icon?: ReactNode
}

const Input = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { required, info, placeholder, className, icon, ...rest } = props
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)}>
      <div className={clsx('inputWrapper', { inputWrapperIconSpace: !!icon })}>
        <input className={clsx({ inputIconSpace: !!icon })} ref={ref} {...rest} required={required} placeholder=" " />
        <div className={clsx(classes.placeholder, { [classes.placeholderIconSpace]: !!icon })}>
          {required && <span className={classes.required}>*</span>}
          {placeholder}
        </div>
        <div className={classes.icon}>{icon}</div>
      </div>
      {info && <div className={classes.info}>{info}</div>}
    </div>
  )
})

export default Input
